import { useContext } from 'react';

import { TenantContext } from './TenantContext';
import type { TenantContextValue } from './tenantTypes';

/** Access the active tenant context. Must be used within a `TenantProvider`. */
export function useTenant(): TenantContextValue {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider.');
  }
  return context;
}
